rdefine('app/products/properties/AR',['backbone','text!products/prop/ar.html'],function(Backbone, template) {
    var arUploadFactory = 0;

    var ZIPLoaderEx = function(){ this.init(); return this; };
    _.extend(ZIPLoaderEx.prototype, {
        init:function() {
            console.log("zip loader done");
        },
        loadFromFile:function(file) {
            var promise = JSZip.external.Promise;
            var baseUrl = './';//'' + window.location.protocol + "//" + window.location.host + window.location.pathname + "/" ;
            return new promise(function(resolve, reject){

                var reader = new FileReader();
                reader.readAsArrayBuffer(file);
                reader.onload = function () {
                    resolve(reader.result);
                };
                reader.onerror = function (error) {
                    reject(error);
                };
            }).then(function(buffer){
                var zip = new JSZip();
                return zip.loadAsync( buffer );
            }).then( function ( zip ) {

                var fileMap = {};

                var pendings = [];

                for ( var file in zip.files ) {

                    var entry = zip.file( file );

                    if ( entry === null ) continue;

                    pendings.push( entry.async( 'blob' ).then( function ( file, blob ) {

                        fileMap[ baseUrl + file ] = URL.createObjectURL( blob );

                    }.bind( this, file ) ) );

                }

                return promise.all( pendings ).then( function () {
                    return fileMap;

                } );

            } ).then( function ( fileMap ) {
                console.log(fileMap);
                return {

                    urlResolver: function ( url ) {
                        console.log("resolve", url);
                        return fileMap[ url ] ? fileMap[ url ] : url;

                    },

                    find: function ( query ) {
                        console.log("find",query );
                        if ( typeof query === 'string' ) {

                            query = new RegExp( query.replace( /\./g, '\\.' ) );

                        }

                        var files = [];

                        for ( var key in fileMap ) {

                            if ( key.match( query ) !== null ) {

                                files.push( key );

                            }

                        }

                        return files;

                    }

                };

            } );
        },
        loadFromUrl:function(url) {
            var promise = JSZip.external.Promise;
            var baseUrl = './';//'' + window.location.protocol + "//" + window.location.host + window.location.pathname + "/" ;
            console.log("LOADING ZIP FROM",url);
            return new promise(function(resolve, reject){
                JSZipUtils.getBinaryContent(url, function(err, data) {
                    if(err) {
                        return reject();
                    }

                    resolve(data);
                });

            }).then(function(buffer){
                var zip = new JSZip();
                return zip.loadAsync( buffer );
            }).then( function ( zip ) {

                var fileMap = {};

                var pendings = [];

                for ( var file in zip.files ) {

                    var entry = zip.file( file );

                    if ( entry === null ) continue;

                    pendings.push( entry.async( 'blob' ).then( function ( file, blob ) {

                        fileMap[ baseUrl + file ] = URL.createObjectURL( blob );

                    }.bind( this, file ) ) );

                }

                return promise.all( pendings ).then( function () {
                    return fileMap;

                } );

            } ).then( function ( fileMap ) {
                console.log(fileMap);
                return {

                    urlResolver: function ( url ) {
                        console.log("resolve", url);
                        return fileMap[ url ] ? fileMap[ url ] : url;

                    },

                    find: function ( query ) {
                        console.log("find",query );
                        if ( typeof query === 'string' ) {

                            query = new RegExp( query.replace( /\./g, '\\.' ) );

                        }

                        var files = [];

                        for ( var key in fileMap ) {

                            if ( key.match( query ) !== null ) {

                                files.push( key );

                            }

                        }

                        return files;

                    }

                };

            } );
        },
        loadZip:function() {

        }
    });

    return Backbone.Ribs.View.extend({
        tagName:'div',
        className:'ar-property',
        camera:null,
        controls:null,
        scene:null,
        renderer:null,
        container:null,
        engine:null,
        ziploader:null,
        maxis:false,
        bindings:{
            '.uploader':{
                toggle:{data:['pmodel.id','pmodel.uploaded', 'pmodel.deleted'], processor:function(a,b,c ) { return (!a && !b) || c ; }}
            },
            '.renderer': { toggle: {data:['pmodel.id','pmodel.uploaded', 'pmodel.deleted'], processor:function(a,b,c) { return (a || b) && !c; }} },
            '.progress-bar .bar':{
                css:{
                    width:{
                        data:'pmodel.loading',
                        processor:function(loading) {
                            return Math.ceil(loading*248) + 'px';
                        }
                    }
                }
            },
            '.progress-bar span':{
                text:{
                    data:'pmodel.loading',
                    processor:function(loading) {
                        return Math.ceil(loading*100) + '%';
                    }
                }
            }
        },
        events:{
            "click .btn-danger":"removeModel",
            "click .btn-default":"makeOtherSize"
        },
        initialize:function(options) {
            this.pmodel = new Backbone.Ribs.Model({id:null});
            this.cform = options.cform;
            this.$el.html(Template7.compile(template)({ndx: arUploadFactory++}));
            this.container = this.$el.find(".renderer");
            this.field = 'property_' + this.model.get("id");

            this.attachFileUploadFactory(this.$el.find("input")[0]);
            this.ziploader = new ZIPLoaderEx();
            try {
                this.modelval = JSON.parse(this.cform.get(this.field));
                this.pmodel.set(this.modelval);
            } catch (e) {
                this.modelval = {};
                this.pmodel.set(this.modelval);

            }
            this.pmodel.on("change",function() {
                console.log('set pmodel',JSON.stringify(this.pmodel.attributes));
                this.cform.set(this.field, JSON.stringify(this.pmodel.attributes),{slient:false});
                //this.cform.trigger('change:'+this.field);
            }.bind(this));

            if(this.pmodel.get("id",0)>0) {
                this.loadingUrl();
            }
        },
        attachFileUploadFactory:function(el) {
            var content = $(el).parent().find('label')[0];
            content.addEventListener('dragover', this.handleDragOver.bind(this));
            content.addEventListener('dragleave', this.handleDragLeave.bind(this));
            content.addEventListener('drop', this.handleDrop.bind(this));
            el.addEventListener('change', this.handleFileSelect.bind(this));
        },
        handleDragOver: function (e) {
            e.preventDefault();
            if(!this.$el.hasClass("hover-drag"))
                this.$el.addClass("hover-drag");
        },
        handleDragLeave: function (e) {
            e.preventDefault();
            this.$el.removeClass("hover-drag");
        },
        handleDrop:function (e) {
            e.preventDefault();
            this.$el.removeClass("hover-drag");
            var file = e.dataTransfer.items || e.dataTransfer.files;
            this.handleFileItems(e.dataTransfer.items || e.dataTransfer.files);
        },
        handleFileSelect:function(e) {
            this.handleFileItems(e.target.files);
        },
        handleFileItems:function(items) {
            var l = items.length;
            for (var i=0; i<l; i++) {
                this.handleItem(items[i]);
                break;
            }
        },
        handleItem:function(item) {

            // get file from item
            var file = item;
            if (item.getAsFile && item.kind =='file') {
                file = item.getAsFile();
            }

            this.loadingFile(file);
            //this.$el.find("input")[0].value = '';
        },
        initEngine:function() {
            this.camera = new THREE.PerspectiveCamera( 45, this.container.width() / this.container.height() , 0.25, 1000 );
            this.camera.position.set( - 1.8, 0.9, 2.7 );

            this.scene = new THREE.Scene();
            this.scene.background = new THREE.Color( 0xFFFFFF );

            this.light = new THREE.AmbientLight( 0x606060 );
            this.scene.add(this.light);

            var light = new THREE.PointLight( 0xffffff, 1, 10000 );
            light.position.set( 0, 10, 0 );
            light.castShadow = true;            // default false
            this.scene.add(light);
            //Set up shadow properties for the light
            light.shadow.mapSize.width = 4096;  // default
            light.shadow.mapSize.height = 4096; // default
            light.shadow.camera.near = 0.5;       // default
            light.shadow.camera.far = 10000;      // default

            this.upVector = new THREE.Vector3(0,1,0);


            var planeGeometry = new THREE.BoxBufferGeometry( 100, 0.1, 100);
            this.planeMaterial = new THREE.ShadowMaterial();
            this.planeMaterial.opacity = 0.5;
            this.plane = new THREE.Mesh( planeGeometry, this.planeMaterial );
            this.plane.receiveShadow = true;
            this.plane.position.set(0,-1,0);
            this.scene.add( this.plane );

            this.renderer = new THREE.WebGLRenderer( { antialias: true } );
            this.renderer.setPixelRatio( window.devicePixelRatio );
            this.renderer.setSize( this.container.width(), this.container.height() );
            this.renderer.gammaOutput = true;
            this.renderer.gammaOutput = true;
            this.renderer.gammaFactor = 2.2;
            this.renderer.shadowMap.enabled = true;
            this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
            //this.renderer.setClearColor( 0xffffff, 0);
            this.container[0].appendChild(this.renderer.domElement);

            this.engine = true;

            this.controls = new THREE.OrbitControls( this.camera, this.renderer.domElement );
            this.controls.target.set( 0, 0, 0 );
            this.controls.autoRotate = true;
            this.render();
            //dragControls = new THREE.DragControls([], this.camera, this.renderer.domElement);
        },
        render:function() {
            if(!this.engine) { return false; }
            requestAnimationFrame(this.render.bind(this));
            this.controls.update();
            this.renderer.render(this.scene, this.camera);
            var theta = Math.acos( this.upVector.dot(this.camera.position) / (this.camera.position.length()) ) * (180/Math.PI);
            theta = Math.min(1,Math.max(0,1 - ((theta - 85) / 5)));
            this.planeMaterial.opacity = theta / 2;
        },
        destroyEngine:function() {
            this.engine = false;
            this.renderer ? this.renderer.domElement.remove() : '';
            this.scene = null;
            this.renderer = null;
            this.camera = null;
            this.planeMaterial = null;
            this.plane = null;
            this.controls = null;
            this.pmodel.set('uploaded',false);
        },
        loadingFile:function(file) {
            if(!/^(.*).(zip|glb)$/.test(file.name)) {
                ErrorMessage(window.LANGUAGE['ar-property-wrong-format']);
                return;
            }
            this.destroyEngine();
            var manager = new THREE.LoadingManager();
            manager.onProgress = function(item, loaded, total) {
                if(loaded != total) {
                    _.defer(function(){
                    this.$el.find(".progress-bar").fadeIn(500);
                }.bind(this));
                }

                if(loaded == total) {
                    _.defer(function(){
                    this.$el.find(".progress-bar").fadeOut(500);
                    }.bind(this));
                }
                this.pmodel.set('loading',loaded/total);
            }.bind(this);
            this.updateField(file);
            if(/^(.*).(zip)$/.test(file.name)) {
                this.loadingFileZip(file, manager);
            }
            if(/^(.*).(glb)$/.test(file.name)) {
                this.loadingFileGLB(file, manager);
            }
        },
        loadingFileZip:function(file, manager) {
            this.ziploader.loadFromFile(file).then(function(zip){
                manager.setURLModifier( zip.urlResolver );
                this.initEngine();
                this.pmodel.set('uploaded',true);
                this.pmodel.set('deleted',false);
                var file = zip.find(zip.find( /\.(gltf|glb)$/i )[0])[0];
                new THREE.GLTFLoader( manager ).load( file, function ( gltf ) {
                    gltf.scene.traverse(function(chld){
                        if(chld.isMesh) {
                            chld.castShadow = true; //default is false
                            chld.receiveShadow = false;
                        }
                    });
                    this.scene.add( gltf.scene );
                    //gltf.scene.position.set(0,0,0);
                    this.fitCameraToObject(this.camera, gltf.scene, 1.25, this.controls);
                }.bind(this));
            }.bind(this));
        },
        loadingFileGLB: function(file, manager) {
            this.initEngine();
            this.pmodel.set('uploaded',true);
            this.pmodel.set('deleted',false);

            new THREE.GLTFLoader( manager ).load( URL.createObjectURL(file), function ( gltf ) {
                gltf.scene.traverse(function(chld) {
                    if(chld.isMesh) {
                        chld.castShadow = true; //default is false
                        chld.receiveShadow = false;
                    }
                });
                this.scene.add( gltf.scene );
                //gltf.scene.position.set(0,0,0);
                this.fitCameraToObject(this.camera, gltf.scene, 1.25, this.controls);
            }.bind(this));

        },
        loadingUrl:function(){
            this.destroyEngine();
            var manager = new THREE.LoadingManager();
            manager.onProgress = function(item, loaded, total) {
                if(loaded != total) {
                    _.defer(function(){
                        this.$el.find(".progress-bar").fadeIn(500);
                    }.bind(this));
                }

                if(loaded == total) {
                    _.defer(function(){
                        this.$el.find(".progress-bar").fadeOut(500);
                    }.bind(this));
                }
                this.pmodel.set('loading',loaded/total);
            }.bind(this);
            var type = 'zip';
            $.each(this.pmodel.get('files'), function(i, item) {
                if(/(.*).glb/.test(item)) {
                    type = 'glb';
                }
            });
            if(type == 'zip') {
                this.loadingUrlZip(manager);
            }

            if(type == 'glb') {
                this.loadingUrlGLB(manager);
            }
        },
        loadingUrlZip:function(manager) {
            var hash = this.pmodel.get("hash");
            var part = hash.substr(0,2);
            var path = "/storage/ar/"+part+"/"+hash+"/original.zip";


            this.ziploader.loadFromUrl(path).then(function(zip){
                manager.setURLModifier( zip.urlResolver );
                this.initEngine();
                this.pmodel.set('uploaded',true);
                var file = zip.find(zip.find( /\.(gltf|glb)$/i )[0])[0];
                console.log(file);
                new THREE.GLTFLoader( manager ).load( file, function ( gltf ) {
                    gltf.scene.traverse(function(chld){
                        if(chld.isMesh) {
                            chld.castShadow = true; //default is false
                            chld.receiveShadow = false;
                        }
                    });
                    this.scene.add( gltf.scene );
                    //gltf.scene.position.set(0,0,0);
                    this.fitCameraToObject(this.camera, gltf.scene, 1.25, this.controls);
                }.bind(this));
            }.bind(this));
        },
        loadingUrlGLB: function(manager) {
            var hash = this.pmodel.get("hash");
            var part = hash.substr(0,2);
            var path = "/storage/ar/"+part+"/"+hash+"/model.glb";
            this.initEngine();
            this.pmodel.set('uploaded', true);
            JSZipUtils.getBinaryContent(path, function(err, data) {
                if(err) {
                    return;
                }

                data = new Blob([new Uint8Array(data)]);
                new THREE.GLTFLoader(manager).load( URL.createObjectURL(data), function (gltf) {
                    gltf.scene.traverse(function (chld) {
                        if (chld.isMesh) {
                            chld.castShadow = true; //default is false
                            chld.receiveShadow = false;
                        }
                    });
                    this.scene.add(gltf.scene);
                    //gltf.scene.position.set(0,0,0);
                    this.fitCameraToObject(this.camera, gltf.scene, 1.25, this.controls);
                    this.renderer.setSize( 320,320);
                    this.camera.aspect = 1;
                    this.camera.updateProjectionMatrix();
                }.bind(this));
            }.bind(this));

        },
        updateField:function(file) {
            console.log("UPDATE FIELD");
            var fd = new FormData();
            fd.append('filezip',file);
            fd.append('_token',CSRF);
            this.$el.find(".message").addClass("good").removeClass("bad");
            this.$el.find(".message").text('uploading: 0%');
            this.$el.find(".message").fadeIn();
            $.ajax({
                url: '/zip-ar-property',
                data: fd,
                type: 'POST',
                contentType: false, // NEEDED, DON'T OMIT THIS (requires jQuery 1.6+)
                processData: false, // NEEDED, DON'T OMIT THIS
                success:function(resp) {
                    console.log("resp",resp);
                    if(resp.success) {
                        this.pmodel.set({'rawid':resp.id,deleted:false});
                    }
                    this.$el.find(".message").text('Done');
                    setTimeout(function(){
                        this.$el.find(".message").fadeOut();
                    }.bind(this),500);
                }.bind(this),
                error:function() {
                    console.log('err');
                    this.$el.find(".message").text('uploading: 0%');
                }.bind(this),
                xhr: function () {
                    var xhr = $.ajaxSettings.xhr();
                    xhr.upload.onprogress = function (e) {
                        console.log(Math.floor(e.loaded / e.total * 100) + '%');
                        this.$el.find(".message").text('uploading: '+Math.floor(e.loaded / e.total * 100) + '%');
                    }.bind(this);

                    return xhr;
                }.bind(this)
            });



            /*var reader = new FileReader();
            reader.onload = function() {
                this.pmodel.set('raw',reader.result);
            }.bind(this);
            reader.readAsDataURL(file);*/

        },
        fitCameraToObject: function ( camera, object, offset, controls ) {


            const boundingBox = new THREE.Box3();
            // get bounding box of object - this will be used to setup controls and camera
            boundingBox.setFromObject(object);

            const center = boundingBox.getCenter();

            const size = boundingBox.getSize();
            controls.update();
            controls.target.set(  center.x, center.y, center.z );
            camera.lookAt( center );
            this.plane.position.set(0,center.y - size.y / 2 - 0.05,0);
            camera.updateProjectionMatrix();
            const acenter = new THREE.Vector3();

            const boundingSphere = new THREE.Box3().setFromObject( object ).getBoundingSphere(acenter);

            const scale = 1.4; // object size / display size
            const objectAngularSize = ( camera.fov * Math.PI / 180 ) * scale;
            const distanceToCamera = boundingSphere.radius / Math.tan( objectAngularSize / 2 );
            const len = Math.sqrt( Math.pow( distanceToCamera, 2 ) + Math.pow( distanceToCamera, 2 ) );

            camera.position.set(len, len, len);
            controls.maxDistance = len ;
            controls.update();

            //camera.lookAt( boundingSphere.center );
            //controls.target.set( boundingSphere.center.x, boundingSphere.center.y, boundingSphere.center.z );

            camera.updateProjectionMatrix();
        },
        lerp:function (start, end, amt){
            return (1-amt)*start+amt*end
        },
        makeOtherSize:function(e) {
            if(e) {
                e.preventDefault();
            }
            var renderer = this.$el.find(".renderer");
            var offset = this.$el.offset();
            var size = {width:this.$el.width(), height: this.$el.height()};
            var fromW = window.innerWidth;
            var fromH = window.innerHeight;
            var self = this;
            if(this.maxis) {
                this.maxis = false;

                renderer.animate({
                    width: (size.width/window.innerWidth*100) + '%',
                    height: (size.height/window.innerHeight*100) + '%',
                    top:(offset.top - window.scrollY)+'px',
                    left:offset.left+'px'
                },{duration:500, complete: function(){
                    $(this).removeClass("fullscreen");
                    renderer.css({
                        width: '320px',
                        height: '320px',
                        top:0,
                        left:0
                    });
                    self.onresize();
                }, progress:function(a,b,c) {
                        var w = this.lerp(fromW, 320,b);
                        var h = this.lerp(fromH, 320,b);
                      //  this.renderer.setSize( w, h );
                        this.camera.aspect = w / h;
                        this.camera.updateProjectionMatrix();
                }.bind(this)});

            }else{
                renderer.css({
                    width: (size.width/window.innerWidth*100) + '%',
                    height: (size.height/window.innerHeight*100) + '%',
                    top:(offset.top - window.scrollY)+'px',
                    left:offset.left+'px'
                });
                renderer.addClass("fullscreen");
                renderer.animate({
                    width: '100%',
                    height: '100%',
                    top:'0px',
                    left:'0px'
                },{duration:500,progress:function(a,b,c) {
                        var w = this.lerp(320, fromW,b);
                        var h = this.lerp(320, fromH,b);
                       // this.renderer.setSize( w, h );
                        this.camera.aspect = w / h;
                        this.camera.updateProjectionMatrix();
                    }.bind(this), complete:function(){self.onresize()}});

                this.maxis = true;

            }
            return false;
        },
        onresize:function() {
            if(this.maxis) {
                this.renderer.setSize( window.innerWidth, window.innerHeight );
                this.camera.aspect = window.innerWidth / window.innerHeight;
                this.camera.updateProjectionMatrix();
            }else{
                this.renderer.setSize( 320,320);
                this.camera.aspect = 1;
                this.camera.updateProjectionMatrix();
            }
        },
        removeModel:function(e) {
            e.preventDefault();
            var modal = new ModalWrapper({
                title:window.LANGUAGE['products.property.ar.delete-warring.title'],
                buttons:[
                    {
                        'id':'cancel',
                        title:window.LANGUAGE['basic.cancel'],
                        style:'btn-default',
                        cbs:[],
                        event:'close'
                    },
                    {
                        'id':'delete',
                        title:window.LANGUAGE['basic.delete'],
                        style:'btn-danger',
                        cbs:[
                            this.doRemove.bind(this)
                        ],
                        event:'close'
                    }
                ],
                content:window.LANGUAGE['products.property.ar.modal.delete-warring']
            });
            modal.show();
            return false;
        },
        doRemove:function() {
            this.pmodel.set('deleted',true);
            this.pmodel.set('uploaded',false);
            this.destroyEngine();
        }
    });
});